import { findLocationContent } from '../common/types';
import AuctionLocationImage from '../images/auction.location.png';

// eslint-disable-next-line import/prefer-default-export
export const getFindLocationContent = (): Promise<Array<findLocationContent>> => {
    const locations = [
        {
            BlockTitle: 'Find a location near you',
            Description:
                'CarMax Auctions are held on a weekly basis. You can view and print schedules for every auction location nationwide.',
            stateOptions: [
                { label: 'Select State', value: 'N/A' },
                { label: 'Alabama', value: 'AL' },
                { label: 'Arizona', value: 'AZ' },
                { label: 'California', value: 'CA' },
                { label: 'Colorado', value: 'CO' },
                { label: 'Connecticut', value: 'CT' },
                { label: 'Florida', value: 'FL' },
                { label: 'Georgia', value: 'GA' },
                { label: 'Idaho', value: 'ID' },
                { label: 'Illinois', value: 'IL' },
                { label: 'Indiana', value: 'IN' },
                { label: 'Iowa', value: 'IA' },
                { label: 'Kansas', value: 'KS' },
                { label: 'Kentucky', value: 'KY' },
                { label: 'Louisiana', value: 'LA' },
                { label: 'Maryland', value: 'MD' },
                { label: 'Massachusetts', value: 'MA' },
                { label: 'Minnesota', value: 'MN' },
                { label: 'Missouri', value: 'MO' },
                { label: 'Nevada', value: 'NV' },
                { label: 'New Jersey', value: 'NJ' },
                { label: 'New Mexico', value: 'NM' },
                { label: 'New York', value: 'NY' },
                { label: 'North Carolina', value: 'NC' },
                { label: 'Ohio', value: 'OH' },
                { label: 'Oklahoma', value: 'OK' },
                { label: 'Oregon', value: 'OR' },
                { label: 'Pennsylvania', value: 'PA' },
                { label: 'South Carolina', value: 'SC' },
                { label: 'Tennessee', value: 'TN' },
                { label: 'Texas', value: 'TX' },
                { label: 'Utah', value: 'UT' },
                { label: 'Virginia', value: 'VA' },
                { label: 'Washington', value: 'WA' },
                { label: 'Wisconsin', value: 'WI' },
            ],
            AuctionLocationHeroImageSrc: AuctionLocationImage,
        },
    ];

    return Promise.resolve(locations);
};
